
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-wrap pd-20 mb-20 card-box">
      ePay © 2025. All rights reserved.
    </div>
  );
};

export default Footer;
